module.exports = __webpack_public_path__ + "img/articulated_grapper_instruction_video.ddc21678.jpg";